import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '@/components/common/Flex';
import type { ReactNode } from 'react';

export type OverviewCardItemData = {
  id?: string | number;
  name: ReactNode;
  value?: ReactNode;
  color: string;
};

type OverviewCardItemProps = {
  data: OverviewCardItemData[];
};

const OverviewCardItem = ({ data }: OverviewCardItemProps) => {
  // متون استفاده شده در کارت نمای کلی
  return (
    <>
      {data.map((item, index) => (
        <Flex
          key={index}
          alignItems="baseline"
          justifyContent="start"
          className={`fw-semi-bold fs--1 gap-2 ${index == 0 && 'mt-3'}`}
        >
          <p className="mb-1">
            <FontAwesomeIcon
              icon="circle"
              className={`me-2 text-${
                item.color.split('-')[1] || item.color || 'text-info'
              }`}
            />
            {item.name}:
          </p>
          <div className="fw-black">{item.value}</div>
        </Flex>
      ))}
    </>
  );
};

export default OverviewCardItem;
